<template>
  <v-menu
    v-model="dialogColorPicker"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on, attrs }">
      <v-chip label :color="selectedColor" dark small v-bind="attrs" v-on="on">
        <v-icon small>mdi-palette</v-icon>
      </v-chip>
    </template>
    <v-card>
      <v-color-picker class="ma-2" v-model="selectedColor" elevation="15" show-swatches>
      </v-color-picker>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text color="pageHeader" @click="dialogColorPicker = false" small>
          {{ $t("btnCancel") }}
        </v-btn>
        <v-btn color="pageHeader" text @click="selectColor()" small> Ok </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  name: "ColorSelector",
  data() {
    return {
      dialogColorPicker: false,
      type: "hex",
    };
  },
  props: {
    color: String,
  },
  computed: {
    selectedColor: {
      get() {
        return this.color || '#979797';
      },
      set(value) {
        this.$emit("update:color", value || "#979797");
      },
    },
  },
  methods: {
    selectColor() {
      this.dialogColorPicker = false;
    },
  },
};
</script>